import dayjs from 'dayjs';
import * as React from 'react';
import { useMemo } from 'react';

import { MatchResultInfo } from '@/components/layouts/Modal/MatchDetail';
import { EntryRacerScoreDetailOwn } from '@/lib/apollo/types/gen/graphql';

import TableData from '../Partials/TableData';
import { BorderData } from '../style';
import Content from './Content';
import { Wrapper } from './style';

interface RecentResultDataProps {
  scoreDetailOwns: EntryRacerScoreDetailOwn[];
  viewHeldDate: dayjs.Dayjs;
  isFirstDay: boolean;
  isVelodromeResult: boolean;
  openRaceResultModal: (
    matchResult: MatchResultInfo,
    highlightTarget: number,
  ) => void;
}

const DISPLAY_COUNT = Number(import.meta.env.VITE_RACER_SCORE_DETAIL_COUNT); // 直近成績表示数（ENVから取得）
const DISPLAY_COUNT_VELODROME = Number(
  import.meta.env.VITE_RACER_SCORE_DETAIL_COUNT_VELODROME,
); // 当場成績表示数（ENVから取得）

const RecentResultData: React.FC<RecentResultDataProps> = ({
  scoreDetailOwns,
  viewHeldDate,
  isFirstDay,
  openRaceResultModal,
  isVelodromeResult,
}) => {
  const displayCount = useMemo(
    () => (isVelodromeResult ? DISPLAY_COUNT_VELODROME : DISPLAY_COUNT),
    [isVelodromeResult],
  );

  const scoreDetailOwnsSlice = useMemo(() => {
    if (scoreDetailOwns) {
      if (scoreDetailOwns.length >= displayCount) {
        return scoreDetailOwns.slice(0, displayCount);
      } else {
        return scoreDetailOwns.slice();
      }
    }
    return [];
  }, [scoreDetailOwns]);

  const viewDummyArea = (owns: EntryRacerScoreDetailOwn[]) => {
    return owns.length < displayCount;
  };

  return (
    <>
      {scoreDetailOwnsSlice.map((own, i) => (
        <TableData key={`recent-data-${i}`}>
          <Wrapper>
            <Content
              own={own}
              viewHeldDate={viewHeldDate}
              isFirstDay={isFirstDay}
              index={i}
              openRaceResultModal={openRaceResultModal}
            />
          </Wrapper>
        </TableData>
      ))}
      {viewDummyArea(scoreDetailOwns) &&
        [...Array(displayCount - scoreDetailOwns.length)].map((_, i) => (
          <BorderData
            key={`recent-data-${i}`}
            data-testid="table-data"
            isBorderRightNone={true}
          />
        ))}
    </>
  );
};

export default RecentResultData;
